import "./About01.css";

import img from "./../../../img/cont/1.webp";

function About01() {
  return (
    <div className="About01 section" id="About01">
      <div className="container">
        <div className="About01-box">
          <div>
            <p className="eyebrow">About Us </p>
            <h2>Our Mission: A World Without Tyre Waste</h2>
            <p>
              Founded in 2025, Global Tyres Recycling Ltd. was born from a
              desire to challenge the status quo of the waste management
              industry.
            </p>
            <p>
              We saw that "disposal" was not a real solution and that
              end-of-life tyres held immense, untapped potential. Our mission is
              to unlock that potential.
            </p>

            <a href="#Reviews01" className="btn-1">
              CHECK OUR REVIEWS
            </a>
          </div>

          <img src={img} alt="" />
        </div>
      </div>
    </div>
  );
}

export default About01;
